export const getSummaryStepStyle = () => ({
  root: {
    '& .unmapped-server-errors': {
      marginTop: '16px',
      marginBottom: '16px',
    },
  },
  heading: {
    '& .panel-header': {
      '& .title': {
        margin: '0px',
      },
    },
  },
});
